// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jp8QQXpvQyT2Ao {
  display: block;
  align-items: center;
  justify-content: left;
  padding: 12px 2px 12px 12px;
  color: var(--ds-text-inverse, #ffffff);
  font-family: var(--ds-font-family-body, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Noto Sans', 'Ubuntu', 'Droid Sans', 'Helvetica Neue', sans-serif);
  font-weight: var(--ds-font-weight-regular, 400);
}
.Jp8QQXpvQyT2Ao.ecOU7oNtr_JWyv {
  display: flex;
  flex-direction: row;
}
.z0tpbd1Y1U0nGU {
  box-shadow: var(--ds-shadow-raised, 0px 1px 1px #091e4240, 0px 0px 1px #091e424f);
}
.IBgkHU2a8Zoguc {
  display: flex;
}
.PqTnHgh27TtEAh {
  flex-grow: 1;
  width: 100%;
  margin-top: 7px;
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.PqTnHgh27TtEAh.K_3Ufrg5OHN7vf,
.PqTnHgh27TtEAh.K_3Ufrg5OHN7vf a {
  color: var(--ds-text-inverse, #ffffff);
}
.BNcnS_EVEVrMfD {
  border-radius: 3px;
}
.QTcxwXKDxaabC5 {
  align-self: flex-start;
  justify-self: right;
  cursor: pointer;
}
.WWnxgcUyLK203V {
  flex-grow: 1;
  padding-right: 6px;
  color: var(--ds-text, #172b4d);
  font-size: 14px;
  line-height: 24px;
}
.WWnxgcUyLK203V a {
  color: var(--ds-text, #172b4d);
}
.WWnxgcUyLK203V.K_3Ufrg5OHN7vf,
.WWnxgcUyLK203V.K_3Ufrg5OHN7vf a {
  color: var(--ds-text-inverse, #ffffff);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"narrowBannerContainer": `Jp8QQXpvQyT2Ao`,
	"noHeader": `ecOU7oNtr_JWyv`,
	"bannerShadow": `z0tpbd1Y1U0nGU`,
	"topRow": `IBgkHU2a8Zoguc`,
	"headerBody": `PqTnHgh27TtEAh`,
	"lightText": `K_3Ufrg5OHN7vf`,
	"roundedCorners": `BNcnS_EVEVrMfD`,
	"closeButton": `QTcxwXKDxaabC5`,
	"textContent": `WWnxgcUyLK203V`
};
export default ___CSS_LOADER_EXPORT___;
